import clsx from "clsx";

export default function DetailRow({ label, value, showFull = false, icon }) {
  return (
    <tr className={"border-b-2 border-gray-200"}>
      <td className="max-w-80 px-6 py-4 font-bold text-gray-600 break-words whitespace-normal">{label}</td>
      <td className={clsx("max-w-80 px-6 py-4 flex items-center break-words whitespace-normal")}>
        {icon ? (
          <img src={icon} alt="" className="w-4 h-4 mr-3 flex-shrink-0 object-contain" />
        ) : null}
        <div className="min-w-0 break-words whitespace-normal">{value}</div>
      </td>
    </tr>
  );
}
